import { Component } from "react";

// Without this, ANY uncaught render error anywhere in the tree unmounts the
// whole app to a blank white screen with zero diagnostic info — exactly the
// "click a tab, screen goes blank" symptom. This catches it, shows what
// actually broke, and offers a reload instead of a silent dead end.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, componentStack: "" };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ componentStack: info?.componentStack || "" });
    console.error("Unhandled render error:", error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      const details = [this.state.error?.stack, this.state.componentStack]
        .filter(Boolean)
        .join("\n");
      return (
        <div className="app">
          <main>
            <div className="card" style={{ margin: "40px auto", maxWidth: 640 }}>
              <h3>Something went wrong</h3>
              <p className="muted">
                {this.state.error?.message || "An unexpected error occurred."}
              </p>
              <button className="primary" onClick={() => window.location.reload()}>
                Reload
              </button>
              {details && (
                <pre
                  style={{
                    marginTop: 16,
                    padding: 12,
                    background: "var(--input)",
                    borderRadius: 8,
                    fontSize: 11,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    maxHeight: 300,
                    overflow: "auto",
                    userSelect: "text",
                  }}
                >
                  {details}
                </pre>
              )}
            </div>
          </main>
        </div>
      );
    }
    return this.props.children;
  }
}
